var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiLowSodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.906 10.953H8.344l-.342 5.803c-.01.16.016.32.074.47.059.151.15.289.266.405.117.117.258.21.415.273.156.063.325.096.495.096h5.746c.17 0 .339-.033.495-.096.157-.064.298-.156.415-.273.117-.116.207-.254.266-.405.058-.15.084-.31.074-.47zm-2.53 5.476h-2.503a.43.43 0 01-.295-.115c-.078-.074-.122-.174-.122-.278s.044-.204.122-.278a.43.43 0 01.295-.115h2.504a.43.43 0 01.295.115c.078.074.122.174.122.278s-.044.204-.122.277a.43.43 0 01-.295.116zM12.127 7a3.894 3.894 0 00-2.512.91 3.473 3.473 0 00-1.222 2.257h7.466a3.473 3.473 0 00-1.221-2.257A3.894 3.894 0 0012.125 7zm-1.253 2.75a.436.436 0 01-.231-.066.399.399 0 01-.154-.177.371.371 0 01.09-.428.442.442 0 01.455-.085c.076.03.141.08.187.145a.376.376 0 01-.052.496.43.43 0 01-.295.115zm1.252-.786a.436.436 0 01-.232-.066.4.4 0 01-.153-.176.37.37 0 01-.024-.227.387.387 0 01.114-.201.443.443 0 01.455-.085c.076.03.141.08.187.144a.377.377 0 01-.052.496.43.43 0 01-.295.115zm1.252.786c-.083 0-.163-.023-.232-.066s-.122-.105-.154-.177c-.031-.071-.04-.15-.023-.227s.055-.146.114-.2a.441.441 0 01.455-.085c.076.029.141.08.187.144a.377.377 0 01-.052.496.43.43 0 01-.295.115z",
    fill: "#31544e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.041 3.706L4.706 20.959",
    stroke: "#31544e",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--low-sodium-65fcf4848aa1bb3d9743a0e160202dc1.svg";
export { SvgIconUiLowSodium as Component };